/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/**
 * exactlog.module.ts
 * 26-03-2024 - Jelmer Jellema - Spin in het Web B.V. Apeldoorn NL
 * Module voor component Exactlog
 * Selector: exactlog
 */

import {NgModule} from '@angular/core';
import {Exactloglijst} from './exactloglijst.component';
import {SihwDatatable2Module} from 'sihw-ng/datatable2/datatable2.module';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [Exactloglijst],
  imports: [
    SihwDatatable2Module,
    FormsModule
  ],
  exports: [Exactloglijst]
})
export class ExactloglijstModule {
}
Exactloglijst.register('Exactlog');
